import { DEFAULT_LOCALE, isAppLocale, type AppLocale } from '~/utils/i18n';

export const ensureAbsolutePath = (path: string) =>
  path.startsWith('/') ? path : `/${path}`;

export const resolveAppLocale = (value?: string): AppLocale =>
  isAppLocale(value) ? value : DEFAULT_LOCALE;

export const ensureLocalePrefixedPath = (path: string, locale: string) => {
  const normalized = ensureAbsolutePath(path);

  // If it's already a locale-prefixed path, return as-is
  if (normalized.startsWith('/$locale')) {
    return normalized;
  }

  const validLocale = resolveAppLocale(locale);

  // For default locale, use root path without /$locale prefix
  if (validLocale === DEFAULT_LOCALE) {
    return normalized;
  }

  // For non-default locales, add /$locale prefix
  if (normalized === '/') {
    return '/$locale';
  }
  return `/$locale${normalized}`;
};

export const buildLocaleParams = (
  locale: AppLocale,
  params?: Record<string, unknown>
) => (locale === DEFAULT_LOCALE ? params : { locale, ...params });
